
import React, {FC, useEffect} from 'react';
import {usePermissions} from 'hooks/usePermissions';
import {Endpoints, postValues} from 'utils/n8n';

import {Dots} from './Dots';

import * as styles from './styles.module.scss';

type PreparingProps = {
	onReport: (report: string, source: string) => void
};

type ReportRequest = {
	user: {
		id: string
	}
	options?: {
		force?: boolean
		random?: boolean
	}
}

type ReportResult = {
	report: {
		id: string
		source: string
	}
	generated: boolean
}

export const Preparing: FC<PreparingProps> = ({onReport}) => {
	const {auth} = usePermissions();

	// If we have a valid ID, prepare the report
	useEffect(() => {
		if (auth.user?.id) {
			const id = auth.user.id;
			(async () => {
				const request: ReportRequest = {
					user: {
						id,
					},
					options: {
						force: true,
					},
				};

				const result = await postValues(
					Endpoints.voiceReport, request,
				);

				if (result && result.ok) {
					const obj: ReportResult = await result.json();
					onReport(obj.report.id, obj.report.source);
				}
			})();
		}
	}, [auth.user?.id]);

	return (
		<div className={styles.preparing}>
			<Dots />
			<h1>
				Preparing your results
			</h1>
			<p>
				We're pulling everything together.
				This usually takes about 30 seconds.
			</p>
		</div>
	);
};
